import State from 'store/State';
import { selectWidgetInstancesState } from 'widgets/store/selectors';
import { WidgetType } from 'widgets/WidgetType';

export const selectPlCapsulesState = (state: State) =>
    selectWidgetInstancesState(state)[WidgetType.PL_CAPSULE];

export const selectPlCapsuleState = (state: State, widgetKey: string) =>
    selectPlCapsulesState(state)[widgetKey];
